module.exports = __webpack_public_path__ + "static/media/bytt-no-5.64e6ba15.mp3";